import React, { useEffect, useState } from 'react';
import { Bar } from 'react-chartjs-2';
import axios from 'axios';
import { hexToRGB } from '../../utils/Utils';

// Register Chart.js components if not already registered
import {
  Chart,
  Tooltip,
  LineController,
  LineElement,
  PointElement,
  LinearScale,
  CategoryScale,
  BarController,
  BarElement,
  Filler,
} from 'chart.js';

Chart.register(
  Tooltip,
  LineController,
  LineElement,
  PointElement,
  LinearScale,
  CategoryScale,
  BarController,
  BarElement,
  Filler
);

// Define Chart.js default settings
Chart.defaults.font.family = '"Inter", sans-serif';
Chart.defaults.font.weight = 500;
Chart.defaults.plugins.tooltip.borderWidth = 1;
Chart.defaults.plugins.tooltip.displayColors = false;
Chart.defaults.plugins.tooltip.mode = 'nearest';
Chart.defaults.plugins.tooltip.intersect = false;
Chart.defaults.plugins.tooltip.position = 'nearest';
Chart.defaults.plugins.tooltip.caretSize = 0;
Chart.defaults.plugins.tooltip.caretPadding = 20;
Chart.defaults.plugins.tooltip.cornerRadius = 8;
Chart.defaults.plugins.tooltip.padding = 8;

// Function that generates a gradient for line charts
export const chartAreaGradient = (ctx, chartArea, colorStops) => {
  if (!ctx || !chartArea || !colorStops || colorStops.length === 0) {
    return 'transparent';
  }
  const gradient = ctx.createLinearGradient(0, chartArea.bottom, 0, chartArea.top);
  colorStops.forEach(({ stop, color }) => {
    gradient.addColorStop(stop, color);
  });
  return gradient;
};

// Chart colors configuration with hard-coded values
export const chartColors = {
  textColor: {
    light: '#9CA3AF', // gray.400
    dark: '#6B7280',  // gray.500
  },
  gridColor: {
    light: '#F3F4F6', // gray.100
    dark: `rgba(${hexToRGB('#374151')}, 0.6)`, // rgba(gray.700, 0.6)
  },
  backdropColor: {
    light: '#FFFFFF', // white
    dark: '#1F2937',  // gray.800
  },
  tooltipTitleColor: {
    light: '#1F2937', // gray.800
    dark: '#F3F4F6',  // gray.100
  },
  tooltipBodyColor: {
    light: '#6B7280', // gray.500
    dark: '#9CA3AF',  // gray.400
  },
  tooltipBgColor: {
    light: '#FFFFFF', // white
    dark: '#374151',  // gray.700
  },
  tooltipBorderColor: {
    light: '#E5E7EB', // gray.200
    dark: '#4B5563',  // gray.600
  },
};

// Initialize Chart.js defaults
Chart.defaults.responsive = true;
Chart.defaults.maintainAspectRatio = false;

function DashboardCard06({ stockSymbol }) {
  const [recommendationKey, setRecommendationKey] = useState(null);
  const [numberOfAnalystOpinions, setNumberOfAnalystOpinions] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAnalystRatings = async () => {
      try {
        console.log(`Fetching analyst ratings for: ${stockSymbol}`);

        const response = await axios.get(`https://investorverden.onrender.com/api/financials?q=${stockSymbol}`);
        
        console.log('API response:', response.data);

        setRecommendationKey(response.data.financialData?.recommendationKey || null);
        setNumberOfAnalystOpinions(response.data.financialData?.numberOfAnalystOpinions || null);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching analyst ratings:', error);
        setLoading(false);
      }
    };

    if (stockSymbol) {
      fetchAnalystRatings();
    } else {
      console.error('No stockSymbol provided');
    }
  }, [stockSymbol]);

  const chartData = {
    labels: ['Recommendation'],
    datasets: [
      {
        label: 'Analytikers anbefaling',
        data: [recommendationKey ? 1 : 0],
        backgroundColor: recommendationKey ? '#3EC972' : '#FF5656', // green.500 : red.500
        hoverBackgroundColor: recommendationKey ? '#34BD68' : '#FA4949', // green.600 : red.600
        borderWidth: 1,
      },
      {
        label: 'Number of Analyst Opinions',
        data: [numberOfAnalystOpinions ? 1 : 0],
        backgroundColor: numberOfAnalystOpinions ? '#3EC972' : '#FF5656', // green.500 : red.500
        hoverBackgroundColor: numberOfAnalystOpinions ? '#34BD68' : '#FA4949', // green.600 : red.600
        borderWidth: 1,
      },
    ],
  };

  const chartOptions = {
    scales: {
      x: {
        beginAtZero: true,
      },
      y: {
        beginAtZero: true,
        ticks: {
          precision: 0,
        },
      },
    },
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
    },
  };

  if (loading) {
    return <div>Loader...</div>;
  }

  return (
    <div className="col-span-full xl:col-span-12 bg-white dark:bg-gray-800 shadow-sm rounded-xl">
      <header className="px-5 py-4 border-b border-gray-100 dark:border-gray-700/60">
        <h2 className="font-semibold text-gray-800 dark:text-gray-100">Analytikers anbefaling</h2>
      </header>
      <div className="px-5 py-3">
        {/* Recommendation text display */}
        {recommendationKey && (
          <div className="mb-4">
            <h3 className="font-medium text-gray-800 dark:text-gray-100">
              Analytikers handlings anbefaling: <span className="font-bold text-green-500">{recommendationKey}</span>
            </h3>
            <br />
            <h3 className="font-medium text-gray-800 dark:text-gray-100">
              Antal børshuse der dækker aktien : <span className="font-bold text-green-500">{numberOfAnalystOpinions}</span>
            </h3>
          </div>
        )}
      
       
      </div>
    </div>
  );
}

export default DashboardCard06;